import { useContext } from "react";

import camelcaseKeys from "camelcase-keys";
import { isEmpty, kebabCase } from "lodash-es";
import { UseFormReturn } from "react-hook-form";
import snakecaseKeys from "snakecase-keys";

import { postJsonRequest, patchJsonRequest } from "Helpers/ApiRequest";

import useForm from "../app/Atoms/Form";
import { JourneyContext } from "./JourneyContext";
import { Journey, JourneySchema } from "./types";

export const savePreSignUpJourney = async ({
  uuid,
  ...params
}: Partial<Journey & { currentPage: string }>): Promise<Journey> => {
  const requestParams = snakecaseKeys({ preSignUpJourney: params });
  const { body } = uuid
    ? await patchJsonRequest({
        url: `/pre_sign_up_journeys/${uuid}`,
        body: requestParams,
      })
    : await postJsonRequest({
        url: "/pre_sign_up_journeys",
        body: requestParams,
      });

  return JourneySchema.parse(camelcaseKeys(body));
};

export const userFieldsFrom = (journey: Journey) => {
  return snakecaseKeys({
    preSignUpJourneyUuid: journey.uuid,
    companyName: journey.venueName,
    styleOfBusiness: journey.styleOfBusiness,
    country: journey.countryCode,
    contactNumber: journey.phoneNumber,
    email: journey.email,
    firstName: journey.firstName,
    lastName: journey.lastName,
  });
};

export const guessEmail = (journey: Journey): string => {
  console.log({ journey });
  if (isEmpty(journey.firstName)) {
    return "";
  }

  const tld =
    {
      NZ: "co.nz",
      AU: "com.au",
      UK: "co.uk",
      missing: "com",
    }[journey.countryCode || "missing"] || "com";
  const domain = kebabCase(journey.venueName || "");
  const user = kebabCase((journey.firstName || "").toLowerCase());
  return `${user}@${domain}.${tld}`;
};

export const useJourney = (args?: Partial<UseFormReturn>) => {
  const { loadingState, journey, setJourney } = useContext(JourneyContext);
  const formProps = useForm({
    defaultValues: {
      ...journey,
    },
    ...args,
  });
  const saveJourney = async (data: Journey) => {
    const body = await savePreSignUpJourney({ uuid: journey.uuid, ...data });
    setJourney(body);
  };

  return {
    loadingState,
    journey,
    formProps,
    saveJourney,
  };
};
